// extracted by mini-css-extract-plugin
module.exports = {"choice":"choice_choice__3gGTS","form":"choice_form__29xum","id":"choice_id__1guXx","label":"choice_label__3WtRq","error":"choice_error__31baF"};